import { render, staticRenderFns } from "./conseiller.vue?vue&type=template&id=2c48b46e&scoped=true"
import script from "./conseiller.vue?vue&type=script&lang=ts"
export * from "./conseiller.vue?vue&type=script&lang=ts"
import style0 from "./conseiller.vue?vue&type=style&index=0&id=2c48b46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48b46e",
  null
  
)

export default component.exports